if (!customElements.get('subscription-trigger')) {
  customElements.define(
    'subscription-trigger',
    class SubscriptionTrigger extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.trigger?.addEventListener('click', this.onTriggerClicked.bind(this))
        this.selector?.addEventListener('change', this.onSelectorChanged.bind(this))
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.onTriggerClicked.bind(this))
        this.selector?.removeEventListener('change', this.onSelectorChanged.bind(this))
      }

      onSelectorChanged(event) {
        const key = event.currentTarget.closest('.cart__item')?.getAttribute('data-key') || ''
        const quantity = event.currentTarget.closest('.cart__item')?.querySelector('.js-qty__num')?.value || 1
        const sellingPlanId = event.currentTarget.value

        if (key && sellingPlanId) this.updateCart(key, quantity, sellingPlanId)
      }

      onTriggerClicked(event) {
        const key = event.currentTarget.closest('.cart__item')?.getAttribute('data-key') || ''
        const quantity = event.currentTarget.closest('.cart__item')?.querySelector('.js-qty__num')?.value || 1
        const sellingPlanId = event.currentTarget.getAttribute('data-selling-plan-id')

        if (key && sellingPlanId) this.updateCart(key, quantity, sellingPlanId)
      }

      updateCart(key, quantity, sellingPlan, properties) {
        this.selector?.classList?.add('loading')
        this.trigger?.classList?.add('loading')
        const preCartSection = document.querySelector('.pre-cart[data-section-id]')?.getAttribute('data-section-id')
        const body = {
          id: key,
          quantity: quantity,
          sections: ['header', preCartSection],
          sections_url: window.location.pathname,
        }
        if (properties) body['properties'] = properties
        if (sellingPlan) body['selling_plan'] = sellingPlan
        if (sellingPlan == 'none') body['selling_plan'] = ''
        const options = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': `application/json`
          },
          body: JSON.stringify(body)
        }

        fetch(theme.routes.cartChange, options)
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          const sectionHTML = this.getHTMLElement(parsedState.sections[preCartSection])
          this.replaceElement(sectionHTML, '.pre-cart__form')

      

          const headerHTML = this.getHTMLElement(parsedState.sections['header'])
          this.replaceElement(headerHTML, '#HeaderCartTrigger')
          document.dispatchEvent(
            new CustomEvent("CART_FORM_RERENDERED")
          );
          this.classList.remove('loading')
        })
        .catch((error) => {
          console.log(error)
          this.selector?.classList?.remove('loading')
          this.trigger?.classList?.remove('loading')
        })
        .finally(() => {
          this.selector?.classList?.remove('loading')
          this.trigger?.classList?.remove('loading')
        });
      }

      getHTMLElement(str) {
        return new DOMParser().parseFromString(str, 'text/html')
      }

      replaceElement(html, selector) {
        const src = document.querySelector(selector)
        const dst = html.querySelector(selector)

        if (src && dst) src.innerHTML = dst.innerHTML

        return
      }

      get selector() {
        return this.querySelector('[data-subscription-select]')
      }

      get trigger() {
        return this.querySelector('[data-subscription-trigger]')
      }
    }
  );
}
